export default __webpack_public_path__ + "static/media/black_lock.cf57b5d7.svg";